"use strict";

var _inherits = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _createSuper = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");

var _createClass = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _classCallCheck = require("C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IBlockchainProvider = exports.IBlockchainAuthenticator = exports.IPendingRequests = void 0;

var misc_1 = require("./misc");

var provider_1 = require("./provider");

var IPendingRequests = /*#__PURE__*/_createClass(function IPendingRequests(storage) {
  _classCallCheck(this, IPendingRequests);

  this.storage = storage;
});

exports.IPendingRequests = IPendingRequests;

var IBlockchainAuthenticator = /*#__PURE__*/function (_misc_1$IEvents) {
  _inherits(IBlockchainAuthenticator, _misc_1$IEvents);

  var _super = _createSuper(IBlockchainAuthenticator);

  function IBlockchainAuthenticator(config) {
    var _this;

    _classCallCheck(this, IBlockchainAuthenticator);

    _this = _super.call(this);
    _this.config = config;
    return _this;
  }

  return _createClass(IBlockchainAuthenticator);
}(misc_1.IEvents);

exports.IBlockchainAuthenticator = IBlockchainAuthenticator;

var IBlockchainProvider = /*#__PURE__*/function (_provider_1$IJsonRpcP) {
  _inherits(IBlockchainProvider, _provider_1$IJsonRpcP);

  var _super2 = _createSuper(IBlockchainProvider);

  function IBlockchainProvider(connection, config) {
    _classCallCheck(this, IBlockchainProvider);

    return _super2.call(this, connection);
  }

  return _createClass(IBlockchainProvider);
}(provider_1.IJsonRpcProvider);

exports.IBlockchainProvider = IBlockchainProvider;